"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DeliveryPromiseSaga_1 = tslib_1.__importDefault(require("../../deliveryPromise/sagas/DeliveryPromiseSaga"));
const loadDeliveryPromiseModule = () => ({
    id: 'DeliveryPromise',
    sagas: [DeliveryPromiseSaga_1.default],
});
exports.default = loadDeliveryPromiseModule;
